import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IEditInterventionRequestAction {
  data: {
    categoryId?: number;
    firstVisitDate?: string;
    id: number;
    interventionType?: string;
    invoiceNumber?: string;
    invoiceValueCents?: number;
    noRepair?: boolean;
    priceExclVat?: number;
    quoteApproved?: boolean;
    quoteValueCents?: number;
    repairDate?: string;
    repairEndDate?: string;
    status?: string;
    vatPercentage?: number;
  };
  functions: {
    error: (err: any) => void;
    success?: () => void;
  };
}

function editRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IEditInterventionRequestAction>,
) {
  draft.edit.config.isLoading = true;
}

export default editRequest;
